import { useState } from 'react';
import { UiTags } from 'components/ui';

import SpeakersFullList from 'components/common/event/SpeakersFullList';

import settings from 'json/marathon21.settings.json';

import css from './AllSpeakers.module.scss';
import { SpeakerType } from 'graphql/types';

interface IProps {
  onFilterItemClick(city: string): void;
  speakers: SpeakerType[];
}

export default function AllSpeakers({ onFilterItemClick, speakers }: IProps) {
  const [activeCity, setActiveCity] = useState(settings.cities[0].value);

  const handleTagClick = (city: string) => {
    setActiveCity(city);
    onFilterItemClick(city);
  };

  return (
    <div className={css.block}>
      <div className={css.tags}>
        <UiTags
          tags={settings.cities.map((c) => ({
            label: settings.topics[c.value],
            value: c.value,
          }))}
          selected={activeCity}
          onTagClick={handleTagClick}
        />
      </div>
      <div className={css.grid}>
        <SpeakersFullList speakers={speakers} />
      </div>
    </div>
  );
}
